import { render, staticRenderFns } from "./TenantSelector.vue?vue&type=template&id=d225eb38&scoped=true"
import script from "./TenantSelector.vue?vue&type=script&lang=ts"
export * from "./TenantSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d225eb38",
  null
  
)

export default component.exports